package ru.it_mozaika.sender.common

val EMAIL_REGEX = "[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+".toRegex()
val PHONE_REGEX = "^((\\+7|7|8)+([0-9]){10})\$".toRegex()


var IN_PRODUCTION = true
//var RESPONSE_URL = "https://tr.msbook.ru"
//val BASE_URL: String = if (IN_PRODUCTION) "http://192.168.253.11:22080" else "http://localhost:8083"

val BASE_URL: String = if (IN_PRODUCTION) "https://taras-rocket.ru" else "http://localhost"
const val accountsSession: String = "accounts_token"

val STORE_HEADER = "store-id"
//val PORT = if (IN_PRODUCTION) 22080 else 8083

//val SERVER = if (IN_PRODUCTION) "192.168.253.11" else "localhost"

